import { useTranslation } from 'react-i18next';
import { FiChevronDown } from 'react-icons/fi';
import { Button, Menu } from '@mantine/core';

import { formatToDdMmYyyy } from 'util/date';
import { downloadViaAnchorElem, getDataUriStringFromJson, getJsonFromFetch } from 'util/request';
import { convertSpacesToUnderscores } from 'util/stringUtils';
import showToast from 'actions/toastActions';
import { downloadInferenceLayerShp } from 'store/samplePlans/requests';

type Props = {
  fieldName: string;
  url: string;
  inferenceLayerId?: number;
};

export const DownloadScriptBtn = ({ url, fieldName, inferenceLayerId }: Props) => {
  const { t } = useTranslation();

  const downloadGeoJsonScript = async () => {
    try {
      const geojson = await getJsonFromFetch<GeoJSON.FeatureCollection>(url);
      const date = formatToDdMmYyyy(new Date().toISOString());

      const filename = convertSpacesToUnderscores(
        `tillage_rx-${fieldName}-${date}.geojson`,
      ).toLowerCase();

      if (geojson) {
        const href = getDataUriStringFromJson(geojson);
        downloadViaAnchorElem(href, filename);
      }
    } catch (err) {
      const isAnErrorObject = err instanceof Error;

      showToast(isAnErrorObject ? err.message : t('couldNotDownloadLayer'), 'error');
    }
  };

  const downloadShapefileScript = async () => {
    if (!inferenceLayerId) {
      return;
    }

    try {
      await downloadInferenceLayerShp(inferenceLayerId);
      showToast(t('shapefileDownloadSuccess'), 'success');
    } catch (err) {
      const isAnErrorObject = err instanceof Error;

      showToast(isAnErrorObject ? err.message : t('couldNotDownloadLayer'), 'error');
    }
  };

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button rightSection={<FiChevronDown />}>{t('downloadScript')}</Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item disabled={!inferenceLayerId} onClick={downloadShapefileScript}>
          {t('downloadShpfile')}
        </Menu.Item>
        <Menu.Item onClick={downloadGeoJsonScript}>{t('downloadGeojson')}</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
